import StatusDropdown from './StatusDropdown';
import StatusSteps from './StatusSteps';
import StatusModal from './StatusModal';

type StatusInfoSubComponents = {
  Dropdown: typeof StatusDropdown;
  Steps: typeof StatusSteps;
  Modal: typeof StatusModal;
};

const StatusInfo: StatusInfoSubComponents = () => null;

StatusInfo.Dropdown = StatusDropdown;
StatusInfo.Steps = StatusSteps;
StatusInfo.Modal = StatusModal;

export default StatusInfo;
